export const vHeading = {
  mounted: (el: HTMLElement) => {
    el.classList.add('text-h5', 'text-md-h4', 'font-weight-bold', 'wrap', 'mb-2', 'mb-md-4');
  }
};